exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fade-enter-active,.fade-leave-active{transition:opacity .2s}.fade-enter,.fade-leave-active{opacity:0}.-col-group-container{border-bottom:1px solid #ddd}.-col-group{display:inline-block;margin-bottom:5px;padding:0;width:150px;vertical-align:top}.-col-group-title{display:block;margin:5px;padding:5px;border-bottom:1px solid #ddd;font-size:18px}.-col-group>li{margin-bottom:5px;padding-left:10px;list-style:none;line-height:20px;font-size:12px}.-col-group>li>*{margin:0;vertical-align:middle}.-complex-table{position:relative}.-complex-table table{background:#fff}.-table-body,.-table-footer,.-table-header{position:relative;overflow:scroll}.-fixed-table{position:absolute;top:0}.-fixed-table table{width:auto}.-left-fixed,.-right-fixed{box-shadow:1px 0 5px #ddd}.-summary-row{font-weight:700;background-color:#eee!important}.-page-size-select{display:inline-block;width:65px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue2-datatable-component/dist/min.css
// module id = 941
// module chunks = 2